export const wrapperPage = {
  title: 'Antecipando o futuro.',
  subtitle: 'Solução completa de antecipação ao fornecedor.',
  reverseSubtitle: 'Solução de sacado reverso para sua empresa.',
};
